/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact-us-container[_ngcontent-%COMP%]{display:block;width:100%;position:relative;padding:15px;background-color:#6bbe49;color:#fff;opacity:.8;z-index:2}.contact-us-container[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{text-transform:uppercase}.contact-us-container[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/components/contact-us/contact-us.component.scss.shim.ngstyle.js.pre-build-optimizer.js